import { useTranslation } from "react-i18next";

export default function AboutHero() {
  const { t } = useTranslation();

  return (
    <section id="page-hero" data-dark-section className="relative pt-32 pb-20 lg:pb-28 overflow-hidden bg-[#0A1628]">
      <div className="absolute inset-0 opacity-15">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20topographic%20map%20lines%20pattern%20East%20Africa%20geography%2C%20minimal%20geometric%20pattern%2C%20clean%20lines%2C%20dark%20blue%20monochrome%2C%20cartographic%20design%20texture&width=1920&height=800&seq=about-bg-2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#0A1628] via-[#0A1628]/50 to-transparent" />
      <div className="absolute bottom-0 right-12 w-48 h-48 rounded-full bg-[#0A1628]/10 blur-3xl pointer-events-none" />

      <div className="relative z-10 w-full px-6 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-[#00C2C2] text-xs font-semibold tracking-widest uppercase mb-4">{t("aboutHeroTag")}</p>
          <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t("aboutHeroTitle1")}<br />
            <span className="italic font-light text-[#00C2C2]">{t("aboutHeroTitle2")}</span>
          </h1>
          <p className="text-white/65 text-lg leading-relaxed max-w-2xl">
            {t("aboutHeroDesc")}
          </p>
        </div>
      </div>
    </section>
  );
}
